export default "__VITE_ASSET__HJB50IcF__"